import { render, staticRenderFns } from "./Compartilhar.vue?vue&type=template&id=7ecf6082&"
import script from "./Compartilhar.vue?vue&type=script&lang=js&"
export * from "./Compartilhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports